import { merge } from "lodash";
import { BaseChartOptions } from "./BaseChartOptions";

export const PieOptions = merge({}, BaseChartOptions, {
    chart: {
        type: "pie",
    },
    tooltip: {
        pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
        pie: {
            size: 180,
            center: [80, 90],
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: { enabled: false },
            showInLegend: true,
            innerSize: 115, // Donuts. Krispy Kreme 4tw
        },
    },
    legend: {
        enabled: true,
        // Heights required so we can have a scrollable list of legend items, usually for listings
        height: 120,
        maxHeight: 120,
        width: 220,
        itemMarginTop: 3,
        style: { overflow: "hidden" },
        layout: "vertical",
        verticalAlign: "proximate",
        y: 245, // To get the legend to show right below the pie

        navigation: {
            // This is the navigation for the legend. A scrollable list
            activeColor: "#333",
            animation: "true",
            style: {
                color: "#666666",
                fontSize: "12px",
            },
        },
    },
});
